import { render, staticRenderFns } from "./wechat_public_config.vue?vue&type=template&id=170fdbe3&scoped=true"
import script from "./wechat_public_config.vue?vue&type=script&lang=js"
export * from "./wechat_public_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170fdbe3",
  null
  
)

export default component.exports